import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@tolgee/ngx';

@Pipe({ name: 'dateAgo' })
export class DateAgoPipe extends DatePipe implements PipeTransform {
	private translateService = inject(TranslateService);

	// @ts-ignore
	transform(value: string | Date, showTime: boolean = true): string {
		if (!value) {
			return null;
		}

		const currentDate = new Date();
		const currentDateHours = currentDate.getHours();
		const valueDate = new Date(value);

		// Time difference between value and now
		const seconds = Math.floor((currentDate.valueOf() - valueDate.valueOf()) / 1000);

		const minutes = Math.round(Math.abs(seconds / 60));
		const hours = Math.round(Math.abs(minutes / 60));
		const days = Math.round(Math.abs(hours / 24));

		const year = valueDate.getFullYear();
		if (Number.isNaN(seconds)) {
			return 'NaN';
		} else if (seconds <= 60) {
			// Minute hadn't past
			return this.translateService.instant('now');
		} else if (minutes <= 60) {
			// Amount of minutes passed while it's lower then 1 hour
			return showTime
				? this.translateService.instant('num_of_minutes_ago', { minutes })
				: this.translateService.instant('under_hour_ago');
		} else if (hours <= currentDateHours && hours <= 24) {
			// Amount of hours passed counting current day hours
			return showTime
				? this.translateService.instant('num_of_hours_ago', { hours })
				: this.translateService.instant('today');
		} else if (hours >= currentDateHours && hours <= currentDateHours + 24) {
			// Yesterday means the date is in range of current hours amount + 24 hours of previous day
			return showTime
				? this.translateService.instant('yesterday_with_time', {
						time: this.formatDate(valueDate, 'HH:mm'),
					})
				: this.translateService.instant('yesterday');
		} else if (days <= currentDate.getDay()) {
			// return the date in format - 'Tuesday, 22:05' if the amount of days passed is not greater
			// than current week has
			return showTime
				? `${this.formatDate(valueDate, 'EEEE')}, ${this.formatDate(valueDate, 'HH:mm')}`
				: `${this.formatDate(valueDate, 'EEEE')}, ${this.formatDate(valueDate, 'd MMM')}`;
		} else if (year < currentDate.getFullYear()) {
			return `${this.formatDate(valueDate, 'd MMM yyyy')}`;
		}
		return showTime
			? this.formatDate(valueDate, 'MMM d, HH:mm')
			: this.formatDate(valueDate, 'MMM d');
	}

	formatDate(date: string | number | Date, format: string, timezone?: string): string {
		return super.transform(date, format, timezone, this.translateService.language);
	}
}
